import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, resolveDirective as _resolveDirective, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox } from "vue";
const _hoisted_1 = { class: "w-full flex flex-col justify-center px-6" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "h-80 pt-2" };
const _hoisted_4 = ["onClick", "checked"];
const _hoisted_5 = { key: 1 };
const _hoisted_6 = { class: "relative inline-block w-full text-gray-700" };
const _hoisted_7 = ["onInput"];
const _hoisted_8 = ["selected", "value"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "absolute inset-y-0 right-0 flex items-center px-2 pointer-events-none" }, [
    /*#__PURE__*/ _createElementVNode("svg", {
        class: "w-4 h-4 fill-current",
        viewBox: "0 0 20 20"
    }, [
        /*#__PURE__*/ _createElementVNode("path", {
            d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
            "clip-rule": "evenodd",
            "fill-rule": "evenodd"
        })
    ])
], -1);
const _hoisted_10 = {
    key: 2,
    class: "flex flex-row pt-2"
};
const _hoisted_11 = { class: "flex-grow" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_search_bar = _resolveComponent("search-bar");
    const _component_date_picker = _resolveComponent("date-picker");
    const _component_user_navigation_icon = _resolveComponent("user-navigation-icon");
    const _component_empty_table_state = _resolveComponent("empty-table-state");
    const _component_Table = _resolveComponent("Table");
    const _component_Button = _resolveComponent("Button");
    const _component_modal = _resolveComponent("modal");
    const _directive_infinite_scroll = _resolveDirective("infinite-scroll");
    return (_ctx.show)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 0,
            onClose: _cache[7] || (_cache[7] = ($event) => (_ctx.closeModal())),
            sticky: ""
        }, {
            header: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('vault.addUserToVault')), 1)
            ]),
            actions: _withCtx(() => [
                (_ctx.step === 1)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.step += 1)),
                        colored: _ctx.selectedUsers.length > 0,
                        disabled: _ctx.selectedUsers.length === 0
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('misc.next')), 1)
                        ]),
                        _: 1
                    }, 8, ["colored", "disabled"]))
                    : _createCommentVNode("", true),
                (_ctx.step === 2)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 1,
                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.addUsersToSpace())),
                        colored: ""
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('invite.invite')), 1)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true),
                (_ctx.step === 2)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 2,
                        class: "capitalize mr-2",
                        onClick: _cache[5] || (_cache[5] = ($event) => (_ctx.step = 1))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('misc.previous')), 1)
                        ]),
                        _: 1
                    }))
                    : (_openBlock(), _createBlock(_component_Button, {
                        key: 3,
                        class: "capitalize mr-2",
                        onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.closeModal()))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('misc.cancel')), 1)
                        ]),
                        _: 1
                    }))
            ]),
            default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                    (_ctx.step === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.$t('user.userAdd')), 1),
                            _createVNode(_component_search_bar, {
                                lazy: "",
                                class: "mt-2",
                                ref: "searchBar",
                                searchValue: _ctx.userSearch,
                                "onUpdate:searchValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userSearch) = $event))
                            }, null, 8, ["searchValue"]),
                            _createElementVNode("div", _hoisted_3, [
                                _withDirectives((_openBlock(), _createBlock(_component_Table, {
                                    headers: _ctx.headers,
                                    "default-sort": _ctx.sortedField,
                                    "onUpdate:default-sort": _cache[1] || (_cache[1] = ($event) => ((_ctx.sortedField) = $event)),
                                    "backend-pagination-sorting": "",
                                    onSortChanged: _ctx.sortUsers,
                                    data: _ctx.users,
                                    "is-loading": _ctx.isLoadingUsers
                                }, {
                                    "data-timeLimit": _withCtx(({ row }) => [
                                        _createVNode(_component_date_picker, {
                                            modelValue: row.expiryDate,
                                            "onUpdate:modelValue": ($event) => ((row.expiryDate) = $event),
                                            onSelect: date => _ctx.setSelectedUserExpiry(row, date)
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onSelect"])
                                    ]),
                                    "data-checkbox": _withCtx(({ row }) => [
                                        (_openBlock(), _createElementBlock("input", {
                                            onClick: _withModifiers(($event) => (_ctx.toggleUserToAdd(row)), ["prevent"]),
                                            type: "checkbox",
                                            checked: _ctx.isSelectedUser(row.userId),
                                            key: `${row.userId}_${_ctx.isSelectedUser(row.userId)}`
                                        }, null, 8, _hoisted_4))
                                    ]),
                                    tableEmptyState: _withCtx(() => [
                                        _createVNode(_component_empty_table_state, null, {
                                            icon: _withCtx(() => [
                                                _createVNode(_component_user_navigation_icon, { class: "h-8 w-8 mx-auto text-gray-400" })
                                            ]),
                                            header: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.$t('filter.usersNotFound')), 1)
                                            ]),
                                            _: 1
                                        })
                                    ]),
                                    loading: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('tables.loadingState.userLoading')) + "... ", 1)
                                    ]),
                                    _: 1
                                }, 8, ["headers", "default-sort", "onSortChanged", "data", "is-loading"])), [
                                    [_directive_infinite_scroll, {
                                            trigger: _ctx.getMoreUsers,
                                            options: { limit: 10 },
                                        }]
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === 2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createTextVNode(_toDisplayString(_ctx.$t('invite.sureToAdd')) + " ", 1),
                            _createVNode(_component_Table, {
                                headers: _ctx.headersVerify,
                                data: _ctx.selectedUsers,
                                emptyMessage: _ctx.$t('filter.usersNotFound')
                            }, {
                                "data-permissions": _withCtx(({ row }) => [
                                    _createElementVNode("div", _hoisted_6, [
                                        _createElementVNode("select", {
                                            onInput: e => _ctx.updateUserPermission(e, row),
                                            class: "w-full h-10 pl-3 pr-6 text-base border rounded-lg appearance-none focus:shadow-outline bg-white"
                                        }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.values(_ctx.Permissions).filter(permission => (_ctx.config.env.canAddVaultAdmins ? true : permission !== _ctx.Permissions.VAULT_ADMIN)), (value, index) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                    selected: row.permission === value || 0,
                                                    key: `${value}_${index}`,
                                                    value: value
                                                }, _toDisplayString(_ctx.$t(`vault.roles.${value}`)), 9, _hoisted_8));
                                            }), 128))
                                        ], 40, _hoisted_7),
                                        _hoisted_9
                                    ])
                                ]),
                                _: 1
                            }, 8, ["headers", "data", "emptyMessage"])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.config.env.canRevokeGlobalAdminsAfterVaultCreation && _ctx.selectedUsers.find(user => user.permission === _ctx.Permissions.ADVANCED_VAULT_USER && !user.expiryDate))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                            _withDirectives(_createElementVNode("input", {
                                class: "w-10",
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.revokeAdmins) = $event)),
                                type: "checkbox"
                            }, null, 512), [
                                [_vModelCheckbox, _ctx.revokeAdmins]
                            ]),
                            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('vault.revokeAdmins')), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]),
            _: 1
        }))
        : _createCommentVNode("", true);
}
